import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/app/[lng]/components/blog-components/blog-recent-posts/blog-recent-posts.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/app/icons/facebook-icon.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/app/icons/instagram-icon.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/app/icons/linkedIn-icon.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/app/icons/medium-icon.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/app/icons/Share.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/app/icons/twitter-icon.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/app-dir/link.js");
